// src/authToken.js — the access token lives in memory only (MGMT-0042).
//
// It used to sit in localStorage, which means any XSS on any page of the app
// could read a 12-hour bearer token and walk off with it. Holding it in a module
// variable keeps it out of persistent storage entirely: a reload starts with no
// token and the session is re-established from the httpOnly refresh cookie
// (AuthContext bootstraps by calling /api/auth/refresh).
//
// The cost is one extra request on a cold load, and losing the session in a new
// tab until that refresh completes. That is the intended trade.

let accessToken = null;

export const getAccessToken = () => accessToken;

export const setAccessToken = (token) => {
    accessToken = token || null;
    return accessToken;
};

export const clearAccessToken = () => {
    accessToken = null;
};

// Share links carry their own sentinel rather than a JWT; the real token is the
// UUID in the URL, validated server-side by middleware/validateShareToken.
export const SHARE_TOKEN = 'share-token';

export const isShareToken = (token) => token === SHARE_TOKEN;

// Read the double-submit CSRF token issued alongside the refresh cookie. It is
// deliberately NOT httpOnly — the point is that our own JS can read it and echo
// it back in a header, which a cross-site request cannot do.
export const CSRF_COOKIE_NAME = 'csrf_token';
export const CSRF_HEADER_NAME = 'X-CSRF-Token';

export const getCsrfToken = () => {
    try {
        const match = document.cookie
            .split('; ')
            .find((row) => row.startsWith(`${CSRF_COOKIE_NAME}=`));
        return match ? decodeURIComponent(match.slice(CSRF_COOKIE_NAME.length + 1)) : null;
    } catch (e) {
        return null;
    }
};

// Headers for a cookie-authenticated call (/api/auth/refresh, /api/auth/logout).
export const csrfHeaders = () => {
    const token = getCsrfToken();
    return token ? { [CSRF_HEADER_NAME]: token } : {};
};
